module.exports = __webpack_public_path__ + "img/step1_zh-HK.48f564b4.png";